import "../../../../../node_modules/fslightbox";

// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import DirectorListVideoTile from "./partials/director-list-video-tile";
import DirectorVideoList from "./partials/director-video-list";
import PhotographerListImageTile from "./partials/photographer-list-image-tile";
import VideoVisualPlayer from "./partials/video-visual-player";
import HeaderContactBadge from "./partials/header-contact-badge";
import HeaderMobileMenu from "./partials/header-mobile-menu";
import RecentWorkImageSlider from "./partials/recent-work-image-slider";
import RecentWorkVideoSlider from "./partials/recent-work-video-slider";
import VimeoPlayer from "./partials/vimeo-player";
import RecentWork from "./partials/recent-work";
import CookieNotice from "./partials/cookie-notice";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    const $cookieNotice = $wrapper.querySelector('[data-cookie-notice]');
    if ($cookieNotice) {
        new CookieNotice();
    }

    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-video-visual-player]').forEach($el => new VideoVisualPlayer($el));
    $wrapper.querySelectorAll('[data-header-contact-badge]').forEach($el => new HeaderContactBadge($el));
    $wrapper.querySelectorAll('[data-header-mobile-menu]').forEach($el => new HeaderMobileMenu($el));
    $wrapper.querySelectorAll('[data-recent-work-image-slider]').forEach($el => new RecentWorkImageSlider($el));
    $wrapper.querySelectorAll('[data-recent-work]').forEach($el => new RecentWork($el));
    $wrapper.querySelectorAll('[data-vimeo-player]').forEach($el => new VimeoPlayer($el));
    $wrapper.querySelectorAll('[data-director-video-list]').forEach($el => new DirectorVideoList($el));
    $wrapper.querySelectorAll('[data-recent-work-video-slider]').forEach($el => new RecentWorkVideoSlider($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });

    $wrapper.querySelectorAll('[data-director-list-video-tile]').forEach(($el, index) => {
        new DirectorListVideoTile($el, index * 500);
    });
    $wrapper.querySelectorAll('[data-photographer-list-tile]').forEach(($el, index) => {
        new PhotographerListImageTile($el, 4000, index * 500);
    });
}

(function() {
    window.initDom(document);
})();
